/* eslint-env browser */
export class VFNetwork extends HTMLElement {
  connectedCallback() {
    const data = new vis.network.dotparser.DOTToGraph(this.getAttribute('dot'));
    const options = {
      layout: {
        hierarchical: {
          direction: 'LR',
          sortMethod: 'directed',
          levelSeparation: 100,
        },
      },
    };
    this.network = new window.vis.Network(this, data, options);

    // Refit the graph whenever the container changes size -- e.g. when the
    // node is shown as a small thumbnail and then blown up inside the modal
    // dialog -- so the whole diagram stays visible at any size.
    this.resizeObserver = new ResizeObserver(() => {
      if (!this.network) {
        return;
      }
      this.network.setSize('100%', '100%');
      this.network.redraw();
      this.network.fit({animation: false});
    });
    this.resizeObserver.observe(this);

    // Wire a sibling export control (``[data-vf-network-export]``), if any,
    // to download the diagram as a PNG image.
    const content = this.closest('.vf-modal-trigger__content') || this.parentElement;
    const exportButton = content && content.querySelector('[data-vf-network-export]');
    if (exportButton) {
      exportButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.downloadPNG(exportButton.getAttribute('data-vf-network-export'));
      });
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.network) {
      this.network.destroy();
    }
  }

  /** Download the current diagram as a PNG image. */
  downloadPNG(filename) {
    if (!this.network) {
      return;
    }
    this.network.fit({animation: false});
    this.network.redraw();
    const canvas = this.querySelector('canvas');
    if (!canvas) {
      return;
    }
    // vis-network draws on a transparent canvas; composite it onto a white
    // background so the exported PNG isn't see-through.
    const output = document.createElement('canvas');
    output.width = canvas.width;
    output.height = canvas.height;
    const ctx = output.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, output.width, output.height);
    ctx.drawImage(canvas, 0, 0);

    const link = document.createElement('a');
    link.href = output.toDataURL('image/png');
    link.download = filename || 'flow.png';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
